import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

export default class extends Controller {
  static targets = [ "form", "season" ]

  connect() {
    // console.log("Hello, from the Player Form Controller!", this.element)
    // console.log(this.formTarget)
    // console.log(this.seasonTargets)
  }

  attemptSubmit(event) {
    event.preventDefault();

    // check if at least a single season is selected
    const selectedSeasons = this.seasonTargets.filter((season) => season.checked).map((season) => parseInt(season.value));
    if (selectedSeasons.length === 0) {
      createAlert('info', 'Please select at least one season.');
      return;
    } else {
      this.formTarget.submit();
    }

  }

}

